export enum AnalyticsEventType {
  SelectBoardType = "SelectBoardType",
  ResetBoard = "ResetBoard",
  AddToken = "AddToken",
  MoveToken = "MoveToken",
  RemoveToken = "RemoveToken",
  DrawDrawing = "DrawDrawing",
  EraseDrawing = "EraseDrawing",
  EraseAllDrawings = "EraseAllDrawings",
  DrawLine = "DrawLine",
  EraseLine = "EraseLine",
  EraseAllLines = "EraseAllLines",
  WriteText = "WriteText",
  EditText = "EditText",
  ChangeTextColor = "ChangeTextColor",
  ChangeTextSize = "ChangeTextSize",
  MoveText = "MoveText",
  RemoveText = "RemoveText",
  RemoveAllTexts = "RemoveAllTexts",
  CreateTeam = "CreateTeam",
  ChangeTeamName = "ChangeTeamName",
  AddPlayer = "AddPlayer",
  EditPlayer = "EditPlayer",
  RemovePlayer = "RemovePlayer",
  RemoveTeam = "RemoveTeam",
  SaveAsNewFormation = "SaveAsNewFormation",
  SaveAsFormation = "SaveAsFormation",
  LoadFormation = "LoadFormation",
  RenameFormation = "RenameFormation",
  RemoveFormation = "RemoveFormation",
  ShareFormation = "ShareFormation",
  ReceiveFormation = "ReceiveFormation",
  PromptShareFormation = "PromptShareFormation",
  TakeScreenshot = "TakeScreenshot",
  ShareScreenshot = "ShareScreenshot",
  PrintBoard = "PrintBoard",
  OnboardingUserTypeSelected = "OnboardingUserTypeSelected",
  OnboardingSportSelected = "OnboardingSportSelected",
  OnboardingRoleSelected = "OnboardingRoleSelected",
  OnboardingBoardPurposesSelected = "OnboardingBoardPurposesSelected",
  OnboardingBoardVenuesSelected = "OnboardingBoardVenuesSelected",
  OnboardingCompleted = "OnboardingCompleted",
  TwentyBoardEvents = "TwentyBoardEvents",
  PromptSignIn = "PromptSignIn",
  AcceptPromptSignIn = "AcceptPromptSignIn",
  PromptPreferences = "PromptPreferences",
  AcceptPromptPreferences = "AcceptPromptPreferences",
  SubmitFeedback = "SubmitFeedback",
  SeeLiveEditTogether = "SeeLiveEditTogether",
  OpenLiveEditTogether = "OpenLiveEditTogether",
  ClickSignIn = "ClickSignIn",
  SignIn = "SignIn",
  SignUp = "SignUp",
  SignOut = "SignOut",
}
